import React from 'react';
import { SvgIconProps } from '@mui/material';

export const CandidatesIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="35"
        height="28"
        viewBox="0 0 35 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M28 18.3333C31.3137 18.3333 34 20.9201 34 24.1111V27H31M23.5 12.3735C26.0878 11.7321 28 9.46997 28 6.77776C28 4.08555 26.0878 1.82341 23.5 1.18201M19 6.77778C19 9.96876 16.3137 12.5556 13 12.5556C9.68629 12.5556 7 9.96876 7 6.77778C7 3.5868 9.68629 1 13 1C16.3137 1 19 3.5868 19 6.77778ZM7 18.3333H19C22.3137 18.3333 25 20.9201 25 24.1111V27H1V24.1111C1 20.9201 3.68629 18.3333 7 18.3333Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CandidatesIcon;
